<template>
  <span :class="ns.e('sizes')">
    <z-select :model-value="innerPageSize" :disabled="disabled" :popper-class="popperClass" :popper-style="popperStyle"
      :size="size" :teleported="teleported" :validate-event="false" :append-to="appendSizeTo" @change="handleChange">
      <z-option v-for="item in innerPageSizes" :key="item" :value="item" :label="item + t('z.pagination.pagesize')" />
    </z-select>
  </span>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { isEqual } from 'lodash-unified'
import { ZOption, ZSelect } from '@zoryn/components/select'
import { useLocale, useNamespace } from '@zoryn/hooks'
import { isArray } from '@zoryn/utils'
import { usePagination } from '../usePagination'
import { paginationSizesProps } from './sizes'

defineOptions({
  name: 'ZPaginationSizes',
})

const props = defineProps(paginationSizesProps)
const emit = defineEmits(['page-size-change'])
const { t } = useLocale()
const ns = useNamespace('pagination')
const pagination = usePagination()
const innerPageSize = ref<number>(props.pageSize!)

watch(
  () => props.pageSizes,
  (newVal, oldVal) => {
    if (isEqual(newVal, oldVal)) return
    if (isArray(newVal)) {
      const pageSize = newVal.includes(props.pageSize!)
        ? props.pageSize
        : props.pageSizes[0]
      emit('page-size-change', pageSize)
    }
  }
)

watch(
  () => props.pageSize,
  (newVal) => {
    innerPageSize.value = newVal!
  }
)

const innerPageSizes = computed(() => props.pageSizes)
function handleChange(val: number) {
  if (val !== innerPageSize.value) {
    innerPageSize.value = val
    pagination.handleSizeChange?.(Number(val))
  }
}
</script>
